import React from "react";
import DashboardCard from "./DashboardCard";

const DashboardCards = ({ dashboardData }) => {
  const cardData = [
    {
      title: "Medicine In Stock",
      value: dashboardData?.stock_medicine,
      link: "/medicine/list",
      icon: "https://grofresh-admin.6amtech.com/public/assets/admin/img/dashboard/pending.png"
    },
    {
      title: "Total Sales",
      value: dashboardData?.total_sales,
      link: "/sales/list",
      icon: "https://grofresh-admin.6amtech.com/public/assets/admin/img/dashboard/confirmed.png"
    },
    {
      title: "Low Stock Medicine",
      value: dashboardData?.low_stock,
      link: "/medicine/list",
      icon: "https://grofresh-admin.6amtech.com/public/assets/admin/img/dashboard/packaging.png"
    },
    {
      title: "Out of stock medicine",
      value: dashboardData?.out_of_stock,
      link: "/medicine/list",
      icon: "https://grofresh-admin.6amtech.com/public/assets/admin/img/dashboard/out-for-delivery.png"
    }
  ];

  return (
    <div className="card mb-10px">
      <div className="card-body">
        <div className="row g-2" id="order_stats">
          {cardData.map((card, index) => (
            <div key={index} className="col-sm-6 col-lg-3">
              <DashboardCard {...card} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardCards;